import { useApi } from "helpers/useApi";
export const useRewardsPageSrv = () => {
    const { api } = useApi();
    const httpgetGiftCardDetails = (RewardOn: string, PatientGiftCardName: string) => {
        return api.get(`/api/rewardrequest/membergiftcard?patientRewardDate=${RewardOn}&PatientGiftCardName=${PatientGiftCardName}`)
    }
    return { httpgetGiftCardDetails }
}